import { ThunkAction } from 'redux-thunk'
import { loadProfile } from '.'
import { RootState } from '..'
import { pumpApi } from '../../apis'
import { PumpEntity, PumpFilter } from '../../models'
import {
  PumpAction,
  SET_PUMPS,
  SET_PUMPS_LOADED,
  SET_PUMP_FILTER,
  SET_SELECTED_PUMP,
} from '../types'

export const setPumpFilter = (pumpFilter: PumpFilter): PumpAction => ({
  type: SET_PUMP_FILTER,
  payload: pumpFilter,
})

export const setSelectedPump = (selectedPump?: PumpEntity): PumpAction => ({
  type: SET_SELECTED_PUMP,
  payload: selectedPump,
})

export const setPumps = (pumps: PumpEntity[]): PumpAction => ({
  type: SET_PUMPS,
  payload: pumps,
})

export const setPumpsLoaded = (loaded: boolean): PumpAction => ({
  type: SET_PUMPS_LOADED,
  payload: loaded,
})

export const loadPumps = (): ThunkAction<void, RootState, null, PumpAction> => {
  return async (dispatch) => {
    try {
      dispatch(setPumpsLoaded(false))
      const resp = await pumpApi.getPumps()
      dispatch({
        type: SET_PUMPS,
        payload: resp.data.data,
      })
    } catch (e) {
      if (e.response && e.response.status && e.response.status === 401) {
        dispatch(loadProfile())
        const resp = await pumpApi.getPumps()
        dispatch({
          type: SET_PUMPS,
          payload: resp.data.data,
        })
      }
    } finally {
      dispatch(setPumpsLoaded(true))
    }
  }
}
